import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  schema,
}: SEOHeadProps) {
  const location = useLocation();
  const baseUrl = 'https://www.mangoshipin.com';
  const currentUrl = canonicalUrl || `${baseUrl}${location.pathname}`;

  const defaultTitle = '芒果视频 - 蜜桃视频与糖豆视频之外好用的视频平台 | 芒果视频资源丰富推荐';
  const defaultDesc = '芒果视频作为蜜桃视频、糖豆视频之外的优质推荐，资源丰富播放流畅。对比蘑菇视频、蓝莓视频，芒果视频App好用且免费高清，值得选择的视频平台。';
  const defaultKeywords = '芒果视频,芒果视频推荐,芒果视频好用吗,芒果视频资源,芒果视频App,蜜桃视频,糖豆视频,蘑菇视频,蓝莓视频,视频平台推荐,免费在线观看';

  const finalTitle = title || defaultTitle;
  const finalDesc = description || defaultDesc;
  const finalKeywords = keywords || defaultKeywords;
  const finalOgTitle = ogTitle || finalTitle;
  const finalOgDesc = ogDescription || finalDesc;

  useEffect(() => {
    document.title = finalTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    setMeta('description', finalDesc);
    setMeta('keywords', finalKeywords);
    setMeta('og:title', finalOgTitle, true);
    setMeta('og:description', finalOgDesc, true);
    setMeta('og:url', currentUrl, true);
    setMeta('og:type', ogType, true);
    setMeta('twitter:title', finalOgTitle);
    setMeta('twitter:description', finalOgDesc);

    let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', currentUrl);

    if (schema) {
      let scriptEl = document.querySelector('script[data-schema="mango"]');
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.setAttribute('type', 'application/ld+json');
        scriptEl.setAttribute('data-schema', 'mango');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }
  }, [finalTitle, finalDesc, finalKeywords, finalOgTitle, finalOgDesc, currentUrl, ogType, schema]);

  return null;
}